import React from "react";
import jwt_decode from 'jwt-decode';
import "devextreme/data/odata/store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import plusimg from "../../images/common/plus.png";
import exportimg from "../../images/common/xlsx.png";
import starimg from "../../images/budget/star.png";
import deleteBlue from "../../images/common/deleteBlue.png"
import editimg from "../../images/common/pencil.png";
import history from "../history";
import { Form, Row, Modal, Button as ButtonBootstrap } from "react-bootstrap";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { config } from "../../constants";
import MonthlySetup from './MonthlySetup';
import { exportToExcel } from '../../utils/exportMethods'; 
import { LoadPanel } from 'devextreme-react/load-panel';
import CustomStore from 'devextreme/data/custom_store';
import AddIcon from "../ui/AddIcon";
import CircleSign from "../ui/CircleSign";
import Maximize from "../ui/Maximize";
import Minimize from "../ui/Minimize";
import SmallModal from "../ui/SmallModal";
import ConfirmationModal from "../ui/ConfirmationModal";
import ConfirmationDelete from "../ui/ConfirmationDelete";
import {compare} from "../../utils/compare";
import { LoadingSpinner } from "../ui/LoadingSpinner";
import CustomDataGrid from "../admin_components/pages/customComponents/CustomDataGrid";
import apiClient from '../../utils/apiClient';
import { handleErrorResponse } from '../../utils/apiClient';

const url = config.url.URL;
const budgetUrl = `${url}/BudgetMicroservice`;
const budgetUrlList = `${url}/BudgetMicroservice/List`;
const budgetUrlExport = `${url}/BudgetMicroservice/Export`;
const budgetWithDetailsUrl = `${url}/BudgetMicroservice/BudgetObject/`;
const buyingAgenciesFromCountryUrl = `${url}/BuyingAgencyMicroservice/country/`;
const countriesLoadUrl = `${url}/GeoElementMicroservice/countriesdropdown`;
const maisonsFromCountryUrl = `${url}/MaisonMicroservice/country/`;
const maisonsUrl = `${url}/MaisonMicroservice`;
const mediaUrl = `${url}/MediaMicroservice`;
const subMediaFromMediaUrl = `${url}/SubMediaMicroservice/media/`;
const vehicleFromCountryAndSubmediaUrl = `${url}/VehicleMicroservice/`;
const suggestedagencyfeesUrl = `${url}/AgencyFeesMicroservice/`;
const currencyUrl = `${url}/ExchangeRateMicroservice/sourceCurrencies`;
const positionsLoadUrl= `${url}/PositionMicroservice/dropdown`;
const objectiveLoadUrl = `${url}/ObjectiveFromBudgetMicroservice`;


var loadMyOptions = {};
const isNotEmpty = (value) => value !== undefined && value !== null && value !== '';

const customDataSource = new CustomStore({
  key: 'budgetId',
  remove: (key) => {
    apiClient.delete(`${budgetUrl}`, {
      headers: {
        'key': key
      }
    }).then(response => {
      return response.data;
    });
  },
  load: (loadOptions) => {
    loadMyOptions = {...loadOptions};
    let requestBody = {};
    [
      'filter',
      'searchOperation',
      'searchValue',
      'select',
      'sort',
      'skip',     
      'take',
      'totalSummary', 
      'userData'
    ].forEach((key) => {
      if (key in loadOptions && isNotEmpty(loadOptions[key])) {
        requestBody[key] =  JSON.stringify(loadOptions[key]);
      }
    });

    return apiClient.post(`${budgetUrlList}`, requestBody)
      .then(response => {
        const data = response.data;
        loadMyOptions.take=data.totalCount;
        return {
          data: data.data,
          totalCount: data.totalCount,
          summary: data.summary,
          groupCount: data.groupCount
        };
      })
      .catch((error) => {
        if (error === 'Unauthorized') {
          return;
        }
      });
  },
});


const appName = "";

const  exportBudgetListToExcel = async (apiData) => {
  const headers = [
    { header: 'Year', key: 'calendarYearName', type:'int', width: 10 },
    { header: 'Notes', key: 'comments', width: 30 },
    { header: 'Country/Region', key: 'country', autoFit: true}, 
    { header: 'Maison', key: 'maison', autoFit: true },   
    { header: 'Agency', key: 'buyingAgencyName', autoFit: true },
    { header: 'Media', key: 'mediaName',autoFit: true },
    { header: 'Submedia', key: 'subMediaName', autoFit: true},
    { header: 'Vehicle', key: 'vehicleName', width: 50 },
    { header: 'Publisher', key: 'publisherName', autoFit: true }, 
    { header: 'Objective', key: 'objectiveName', width: 12 },
    { header: 'Currency', key: 'currency', width: 10 },
    { header: 'Net Yearly Total', key: 'netYearly', type:'float', width: 20 }, 
    { header: 'Final Cost Yearly', key: 'finalCostYearly', type: 'float', width: 20 }, 
    { header: 'Created Date', key: 'createdDate', type:'date', width: 15 }, 
    { header: 'Created By', key: 'createdBy', width: 20 },
    { header: 'Last Updated Date', key: 'updatedDate', type:'date', width: 15 },
    { header: 'Last Updated By', key: 'updatedBy', width: 20 }
  ];

  await exportToExcel(headers, apiData, 'budgets_extract', 'Budgets Extract');
}

const LoadSubmenu = (section) => {
  history.push(appName + "/admin" + (section != "" ? "/" + section : ""));
};

class BudgetList extends React.Component {

  customizeText = (cellInfo) => {
    let newDate = cellInfo.valueText;
    let data1= newDate.split('T')[0].split('-');
    data1.splice(2, 0, data1.splice(0,1)[0]);
    newDate = data1.join("/");
    return newDate;
}

  /*
   * Formats a numeric value according to the user's locale settings.
   */
  customizeNumbers = (cellInfo) => {
    let value = cellInfo.valueText;
    const formatter = new Intl.NumberFormat(navigator.language, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    if (value == null || value === '') {
      return formatter.format(0);
    }
    const numberValue = Number(value);

    const formattedNumber = formatter.format(numberValue);
    // Ensure small positives are prefixed with 0 (0.5 -> 0.50) and small negatives also (-.5 -> -0.50)
    const absFormatted = formatter.format(Math.abs(numberValue));
    const absStartsWithDigit = /^\d/.test(absFormatted);
    if (Math.abs(numberValue) < 1) {
      const absWithLeadingZero = absStartsWithDigit ? absFormatted : `0${absFormatted}`;
      return numberValue < 0 ? `-${absWithLeadingZero}` : absWithLeadingZero;
    }

    return formattedNumber;
  };
/*
customizeNumbers = (cellInfo) => {
  let value = cellInfo.valueText;
  var pointLocation = value.indexOf('.');
  var valueLength = value.length;
  
  if(value == ''){
    return '0.00';
  }
  else if(value.indexOf('.') > -1){
    var pointLocation = value.indexOf('.');
    var valueLength = value.length;
    if(valueLength == (pointLocation + 3)){
      return value;
    }
    else if(valueLength == (pointLocation + 2)){
      return value + '0';
    } 
    return value;
  }
  else{
    return value + '.00';
  }
}

*/
  constructor(props) {
    super(props);
    this.applyFilterTypes = [
      {
        key: "auto",
        name: "Immediately",
      },
      {
        key: "onClick",
        name: "On Button Click",
      },
    ];
    this.state = {
      loadOptionss:null,
      resultData:null,
      ignorePermission:false,
      validationState:null,
      showSmallModal: false,
      showSmallModalEdit: false,
      showConfirmationModal: false,
      budgetdetails:"",
      hasLoaded:false,
      yearValidation:true,
      countriesValidation:true,
      maisonValidation:true,
      agencyValidation:true,
      mediaValidation:true,
      submediaValidation:true,
      vehicleValidation:true,
      currencyValidation:true,
      objectiveValidation: true,
      showObjectives: false,
      fullscreen:false,
      showButton: true,
      showStar: false,
      showFilterRow: true,
      showHeaderFilter: false,
      currentFilter: this.applyFilterTypes[0].key,
      showColumnLines: false,
      showRowLines: true,
      showBorders: true,
      rowAlternationEnabled: true,
      showModal: false,
      showEditModal: false,
      budgetStates:{},
      budgetStatesEdit:{},
      technicalState: null,
      netState: null,
      feeState: null,
      isPositionsValid: true,
      netSuperState:null,
      netSuperStateEdit:null,
      duplicationModal: false,
      lengthExceededModal: false,
      selectedId:"",
      exceededLimit: false,
      reachedLimit: false,
      modalSpinner: false,

          agencies: [],
          countries: [],
          medias: [],
          maisons: [],
          allMaison: [],
          subMedias: [],
          vehicles: [],
          currencies: [],
          years: [],
          showUnitPositionSampling: false,
          positions: [],
          objectives: [],
          budgetDetailsData:[],
          edit_budget_year: '',
          edit_buying_agency_id: '',
          edit_maison_id: '',
          edit_country_id: '',
          edit_media_id: '',
          edit_submedia_id: '',
          edit_currency_id: '',
          edit_vehicle_id: '',
          edit_objective_id: '',
          dataSource: null,
          currentPage: 0,
          pageSize: 5,
          pageSizes: [5,10,15] ,
          showPageSizeSelector: true,
          showInfo: true,
          showNavButtons: true,
          suggestedFees: '',
          submediaReadonly: true,
          vehicleReadonly: true,
          comments:'',
          editOptionsYears:[],
          submediaState: false,
          showConfirmationDelete: false,   
          rowInfo: []       
        };
        this.dataGrid = null;
        this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
        this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
        this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);

    this.child = React.createRef();
    this.editChild = React.createRef();
    this.budgetListNameRef = React.createRef();
    this.yearRef = React.createRef();
    this.buyingAgencyRef = React.createRef();
    this.countryRef = React.createRef();
    this.maisonRef = React.createRef();
    this.mediaRef = React.createRef();
    this.subMediaRef = React.createRef();
    this.vehicleRef = React.createRef();
    this.objectiveRef = React.createRef();
    this.currencyRef = React.createRef();    
    this.budgetListCommentsRef = React.createRef();
    this.budgetListIsEnabled = React.createRef();
    this.exportSpinner = React.createRef();
    this.maisonSpinner = React.createRef();
    this.agencieSpinner = React.createRef();
    this.submediaSpinner = React.createRef();
    this.yearRef = React.createRef();
    this.buyingAgencyRef_edit = React.createRef();
    this.yearRef_edit = React.createRef();
    this.countryRef_edit = React.createRef();
    this.maisonRef_edit = React.createRef();
    this.mediaRef_edit = React.createRef();
    this.subMediaRef_edit = React.createRef();
    this.vehicleRef_edit = React.createRef();  
    this.objectiveRef_edit = React.createRef();  
    this.currencyRef_edit = React.createRef();
    this.budgetListCommentsRef_edit = React.createRef();

    this.onRefreshFromMedia = this.onRefreshFromMedia.bind(this);
    this.onRefreshFromSubMedia = this.onRefreshFromSubMedia.bind(this);
    this.onRefreshFromCountry = this.onRefreshFromCountry.bind(this);
    this.onRefreshFromAgency = this.onRefreshFromAgency.bind(this);
    this.onRefreshFromYear = this.onRefreshFromYear.bind(this);
    this.onRefreshFromMaison = this.onRefreshFromMaison.bind(this);
    this.hideLines = this.hideLines.bind(this);
    this.isEnabled = this.isEnabled.bind(this);
  } 

  isEnabled(e) {
    if(!this.state.manage_budget_form)
    {
        return false;
    }
    return !e.row.data.isBackdata;
  }

  selectedChanged(e) {
    this.setState({
      selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0]),
    });
  }

  closeSmallModal = ()=>{
    this.setState({showSmallModal: false});
  }

  closeSmallModalEdit = ()=>{
    this.setState({showSmallModalEdit: false});
  }

  closeSmallModalEdit = ()=>{
    this.setState({showSmallModalEdit: false});
  }

  closeDuplicationModal = ()=>{
    this.setState({duplicationModal: false});
  }

  closeLengthExceededModal = ()=>{
    this.setState({lengthExceededModal: false});
  }

  closeConfirmationModal = ()=>{
    this.setState({ showConfirmationModal: false });
  }

  doubleCloseModals=()=>{
    this.setState({showModal: false, showEditModal: false, showConfirmationModal:false, showUnitPositionSampling: false, duplicationModal: false, subMedias:[]});
  }

    // to refresh our datagrid table and close all modals
    useRefresh = () => {
      this.dataGrid.useRefresh();
      this.setState({
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
      });
    }

    handleClose = () => {
        this.setState({
            showConfirmationModal: true,
            showButton: true,
            yearValidation: true,
            countriesValidation: true,
            maisonValidation: true,
            agencyValidation: true,
            mediaValidation: true,
            submediaValidation: true,
            vehicleValidation: true,
            currencyValidation: true,
            objectiveValidation: true
        });
    };

  openModal = () => {
    this.setState({
      showModal: true,
      showButton: true,
      vehicleReadonly: true,
      submediaReadonly: true,
      vehicles: [],
      submedia: [],
      agencies: this.state.countries.length == 1 ? this.state.agencies : [],
      maisons: this.state.countries.length == 1 ? this.state.maisons : [],
      suggestedFees: "",
      showObjectives: false,
      submediaState: false,
      exceededLimit:false,
      reachedLimit: false,
      objectiveValidation: true
    });
      };

  handleEditClose = () => {
    this.setState({ 
      showConfirmationModal: true,
      showButton:true,
      yearValidation:true,
      countriesValidation:true,
      maisonValidation:true,
      agencyValidation:true,
      mediaValidation:true,
      submediaValidation:true,
      vehicleValidation:true,
      currencyValidation:true,
      objectiveValidation: true
       });
  };

  fullscreenHandler=()=>{
    this.setState(prevState =>({fullscreen: !prevState.fullscreen}));
  }

  addButtonHandler = () => {  
    this.setState({showButton : false});
  };

  addStarHandler = ()=>{
    this.setState({showButton : false},  
      function(){  
        this.budgetListCommentsRef_edit.current.value = this.state.comments;
      });
  }

  //checking if the comment length exceeded 500 character, than show a red msg to notify the user
  checkCommentLength(value)
  {
    const maxLength = 500;

    if (value.length > maxLength) {
      this.setState({
        comment: value.substring(0, maxLength),
        exceededLimit: true,
        reachedLimit: true
      });
    } else if (value.length == maxLength) {
      this.setState({
        comment: value,
        exceededLimit: false,
        reachedLimit: true
      });
    }
    else {
      this.setState({
        comment: value,
        exceededLimit: false,
        reachedLimit: false
      });
    }
  }


  handleCommentChange = (event) => {
    const { value } = event.target;
    this.checkCommentLength(value);
  }

  handleCommentFocus = () => {
    const { comments } = this.state;
    this.checkCommentLength(comments);
  };

  setupChanged(budgetdetails){
    this.setState({budgetdetails:budgetdetails},);
  }

  componentDidMount() {
    const decoded = jwt_decode(localStorage.getItem('token'));
    this.setState({
      access_budget_list: decoded.can_access_budget_list === "true",
      manage_budget_form: decoded.can_manage_budget_form === "true",
      can_export_to_excel: decoded.can_export_to_excel === "true"
    });

    //console.log("decoded")
    //console.log(decoded)

    this.fetchYears();
    this.fetchCountries();
    this.fetchMedias();
    this.fetchCurrencies();
    this.fetchPositions();
    this.fetchObjectives();
    this.fetchMaison();

    if (decoded.can_access_budget_list === "true") {
      const thisDataSource = createStore({
        key: "budgetId",
        loadUrl: `${url}/BudgetMicroservice`,///BudgetByProfileId/${sessionStorage.getItem('ProfileId')}`,
        insertUrl: `${url}/InsertOrder`,
        updateUrl: `${url}/UpdateOrder`,
        deleteUrl: `${url}/BudgetMicroservice`, ///DeleteOrder

        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            'accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'content-type': 'application/json',
          }
        },
        onAjaxError: (e) => {
          const { xhr, error } = e;
          handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
        }
      });
      this.loadData();
    }
}

  compareCurrencies( a, b ) {
    if ( a.sort < b.sort ){
      return -1;
    }
    if ( a.sort > b.sort ){
      return 1;
    }
    return 0;
  }
    
  openEditModal = (e) => {
    this.setState({
      editOptionsYears: e.row.data.calendarYearName,
      rowInfo: e.row.data,
      edit_currency_id: e.row.data.currencyId,
      exceededLimit: false,
      reachedLimit: false,
      objectiveValidation: true,
    });
    const enabledCountries = this.state.countries.filter((obj) => {
      return obj.isEnabled === true;
    });
    this.setState({ countries: enabledCountries });
    if (
      enabledCountries.find((x) => x.geoElementId == e.row.data.countryId) ==
      undefined
    ) {
      var l_Countries = enabledCountries;
      if (!l_Countries.some(country => country.geoElementId === e.row.data.countryId)) {
        l_Countries.push({
          geoElementId: e.row.data.countryId,
          name: e.row.data.country,
        });
      }
      l_Countries.sort(compare);
      this.setState({ countries: l_Countries });
    }

    const enabledAgencies = this.state.agencies.filter((obj) => {
      return obj.isEnabled === true;
    });
    this.setState({ agencies: enabledAgencies });
    if (
      enabledAgencies.find(
        (x) => x.buyingAgencyId == e.row.data.buyingAgencyId
      ) == undefined
    ) {
      var l_Agencies = enabledAgencies;
      if (!l_Agencies.some(agency => agency.buyingAgencyId === e.row.data.buyingAgencyId)) {
        l_Agencies.push({
          buyingAgencyId: e.row.data.buyingAgencyId,
          name: e.row.data.buyingAgencyName,
        });
      }
      l_Agencies.sort(compare);
      this.setState({ agencies: l_Agencies });
    }
    const enabledMaisons = this.state.maisons.filter((obj) => {
      return obj.isEnabled === true;
    });
    this.setState({ maisons: enabledMaisons });
    if (
      enabledMaisons.find((x) => x.maisonId == e.row.data.maisonId) == undefined
    ) {
      var l_Maisons = enabledMaisons;
      if (!l_Maisons.some(maison => maison.organizationId === e.row.data.maisonId)) {
        l_Maisons.push({
          organizationId: e.row.data.maisonId,
          name: e.row.data.maison,
        });
      }
      l_Maisons.sort(compare);
      this.setState({ maisons: l_Maisons });
    }

    //displaying disabled medias in edit dropdown by getting it through our e.row.data
    const enabledMedias = this.state.medias.filter((obj) => {
      return obj.isEnabled === true;
    });
    this.setState({ medias: enabledMedias });
    if (enabledMedias.find((x) => x.mediaId == e.row.data.mediaId) == undefined) {
      var l_Medias = enabledMedias;
      if (!l_Medias.some(media => media.mediaId === e.row.data.mediaId)) {
        l_Medias.push({
          mediaId: e.row.data.mediaId,
          name: e.row.data.mediaName,
        });
      }
      l_Medias.sort(compare);
      this.setState({ medias: l_Medias });
    }

    this.setState({ comments: "", showStar: false, showButton: true }, () => {
      let budgetList = e.row.data;
      let starComments = e.row.data.comments;
      let fromfetch = true;

      if (starComments) {
        this.setState({
          showButton: true,
          showStar: true,
          comments: e.row.data.comments,
        });
      }

      apiClient.get(
        budgetWithDetailsUrl.concat(budgetList.budgetId))
        .then((response) => {
          const data = response.data;
          this.setState(
            {
              budgetDetailsData: data,
              showEditModal: true,
              selectedRowIndex: budgetList.budgetId,
              edit_budget_year: budgetList.calendarYearName,
              edit_country_id: budgetList.countryId,
              edit_maison_id: budgetList.maisonId,
              edit_media_id: budgetList.mediaId,
              edit_submedia_id: budgetList.subMediaId,
              edit_currency_id: budgetList.currencyId,
              edit_buying_agency_id: budgetList.buyingAgencyId,
              edit_objective_id: budgetList.objectiveId,
              edit_vehicle_id: budgetList.vehicleId,
            },
            function () {
              this.currencyRef_edit.current.value = budgetList.currencyId;
              this.fetchVehiclesFromCountryAndSubmedia(
                budgetList.countryId,
                budgetList.subMediaId
              );
              this.fetchSuggestedAgencyFees(
                budgetList.countryId,
                budgetList.subMediaId,
                budgetList.mediaId,
                budgetList.buyingAgencyId,
                budgetList.calendarYearName,
                fromfetch
              );

              this.fetchSubmediasFromMedia(budgetList.mediaId);
              if (
                this.mediaRef_edit.current.selectedOptions[0].text === "Print"
              ) {
                this.setState({
                  showUnitPositionSampling: true,
                  //fullscreen: true,
                  showObjectives: false,
                  submediaState: true,
                });

                this.fetchPositions(budgetList.subMediaId);
              } else {
                if (
                  this.mediaRef_edit.current.selectedOptions[0].text === "Digital"
                ) {
                  this.setState({ showObjectives: true });
                } else {
                  this.setState({ showObjectives: false });
                }
                this.setState({
                  showUnitPositionSampling: false,
                  fullscreen: false,
                  submediaState: false,
                });
              }
            }
          )
        })
    });
  };

  hideLines(){
    //current months
    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth() +1;
    //getting the targetted maison

    let matchingObject;

    if(this.state.showModal){
        if(this.maisonRef.current.value != ""){
        matchingObject = this.state.allMaison.find(obj => obj.organizationId === this.maisonRef.current.value);
      }else return 0;
    }else{
      matchingObject = this.state.allMaison.find(obj => obj.organizationId === this.maisonRef_edit.current.value);
    }
    
    //year created for
    let objectYear = this.state.showModal ? +this.yearRef.current.value : +this.state.editOptionsYears;

        if (matchingObject) {
          //months allowed
          const pastMonthsValue = JSON.parse(matchingObject.pastMonths).PastMonths + 1;

          // First Condition
          if(currentYear < objectYear) return 0;

          //Second Condition
          else if(currentYear === objectYear){
            if(currentMonth <= pastMonthsValue) return 0;
            if(currentMonth > pastMonthsValue) return currentMonth - pastMonthsValue;
          }

          //Third Condition
          else if(currentYear === (objectYear + 1)){
            if(currentMonth < pastMonthsValue) return currentMonth - pastMonthsValue + 12;
            if(currentMonth >= pastMonthsValue) return 12;
          }

          //Fourth Condition
          else if(currentYear === (objectYear + 2)){
            if(pastMonthsValue > 12){
              let z = pastMonthsValue - 12;
              if(currentMonth < z) return currentMonth - z + 12;
              if(currentMonth >= z) return 12;
            } else return 12;
          }

          //Last Condition
          else return 12
      }
  }

  fetchYears() {
    const year = new Date().getFullYear() - 1;
    this.setState({
      years: Array.from(new Array(3), (val, index) => index + year),
    });
  }

  getBudgetDetails(budgetId) {
    apiClient.get(budgetWithDetailsUrl.concat(budgetId))
      .then(response => {
        const data = response.data;
        this.setState({
          budgetDetailsData: data
        })
      })
  }

  onRefreshFromAgency(){  
    this.setState({ suggestedFees: '' })
    //reseting Suggested Fee when Agency changes
    this.fetchSuggestedAgencyFees();
  }

  onRefreshFromYear(){
    this.setState({ suggestedFees: ''})
    //reseting Suggested Fee when Year changes
    this.fetchSuggestedAgencyFees();
    this.child.current.hideLines(true);
  }

  onRefreshFromMaison(){
    // this.child.current.cleanupPositions();
    this.child.current.hideLines(true);
  }

  onRefreshFromCountry() {
    let countryId = this.countryRef.current.value;    
    this.setState({ suggestedFees: '' })
    if (countryId !== "") {
      this.fetchMaisonsFromCountry(countryId);
      this.fetchAgenciesFromCountry(countryId);

      let submediaId = this.subMediaRef.current.value;
      if (submediaId !== "") {
        this.fetchVehiclesFromCountryAndSubmedia(countryId, submediaId);
      } 
    } else { 
        this.setState({
          maisons: [],
          agencies: [],
          vehicles : []
        });
      }
  }

  UpdateMaisonAgenciesFromCountry() {
    let countryId = this.state.edit_country_id;
    if (countryId !== "") {
      this.fetchMaisonsFromCountry(countryId);
      this.fetchAgenciesFromCountry(countryId);
    } else { 
        this.setState({
          maisons: [],
          agencies: [],
          vehicles : []
        });
      }
  }

  UpdateSubmediaFromMedia(){
    let mediaId = this.state.edit_media_id;
    if(mediaId !== ""){
      this.fetchSubmediasFromMedia(mediaId);
    } else {
      this.setState({
        subMedias: [],
        vehicles: []
      });
    }
  }
  
  fetchObjectives() {
    apiClient.get(objectiveLoadUrl)
      .then(response => {
        const data = response.data;
        this.setState({ objectives: data })
      })
      .catch((error) => {
        if (error === 'Unauthorized') {
          return; // Exit the componentDidMount function
        }
      });
  }

  //In case we didnt send an Id we set it by default to ""
  fetchPositions(submediaId = "") {
    apiClient.get(positionsLoadUrl,
      {
        headers: {
          'submediaId': submediaId,
        }
      })
      .then(response => {
        const data = response.data;
        if (data && data.length > 0) {
          this.setState({ positions: data })
        }
      })
  }
  
  fetchCountries() {
    apiClient.get(countriesLoadUrl,
      {
        headers: {
          "Screen": "budgetscreen"
        },
      }
    )
      .then((response) => {
        const data = response.data;
        this.setState(
          { countries: data },
          () => {
            if (data && data.length === 1) {
              this.fetchAgenciesFromCountry(data[0].geoElementId);
              this.fetchMaisonsFromCountry(data[0].geoElementId);
            }
          }
        )
      });
  }

  fetchMaison() {
    apiClient.get(maisonsUrl)
      .then((response) => {
        const data = response.data;
        this.setState({ allMaison: data });
      })
  }

  fetchAgenciesFromCountry(countryId) {
    if(this.state.showModal){
      this.buyingAgencyRef.current.value = '';
    }
    let url = buyingAgenciesFromCountryUrl.concat(countryId);

    this.agencieSpinner.current && this.agencieSpinner.current.showSpinner();
    this.setState({agencies: []})

    apiClient.get(url)
      .then((response) => {
        const data = response.data;
        this.setState({ agencies: data })
      }).catch((error) => {
        console.error("Error fetching fetchAgenciesFromCountry: ", error);
      }).finally(() => {
        this.fetchSuggestedAgencyFees()
        this.agencieSpinner.current && this.agencieSpinner.current.hideSpinner();
      });
  }

  fetchMaisonsFromCountry(countryId) {
    if(this.state.showModal){
      this.maisonRef.current.value = '';
    }
    let url = maisonsFromCountryUrl.concat(countryId);
    
    this.maisonSpinner.current && this.maisonSpinner.current.showSpinner();
    this.setState({maisons: []})

    apiClient.get(url)
      .then((response) => {
        const data = response.data;
        this.setState({ maisons: data })
      })
      .catch((error) => {
        console.error("Error fetching fetchMaisonsFromCountry: ", error);
      }).finally(()=> {
          this.maisonSpinner.current && this.maisonSpinner.current.hideSpinner();
        });
  }

  onRefreshFromMedia(){
    if(this.state.showModal){
      this.vehicleRef.current.value = '';
      this.objectiveRef.current.value = '';
      this.subMediaRef.current.value = '';
      if(this.state.showUnitPositionSampling){ 
      this.child.current.cleanupPositions();
      }
    }

    let mediaId =  this.mediaRef.current.value;
    this.setState({ suggestedFees: '' })
    if(mediaId !== ""){ 
      this.setState({
      subMedias: [],
      vehicles: []
    });
    this.fetchSubmediasFromMedia(mediaId)
     
    } else {
      this.setState({
        subMedias: [],
        vehicles: []
      });
    }
    if(this.mediaRef.current.selectedOptions[0].text === 'Print')
    {
      this.setState({showUnitPositionSampling: true, /*fullscreen:true,*/showObjectives: false});
    }
    else{
      if(this.mediaRef.current.selectedOptions[0].text === 'Digital')
      {
        this.setState({showObjectives: true});
      }
      else{
        this.setState({showObjectives: false});
      }
      this.setState({showUnitPositionSampling: false, fullscreen:false, submediaState: false});
    }
  }

  fetchMedias() {
    apiClient.get(mediaUrl)
      .then((response) => {
        const data = response.data;
        this.setState({ medias: data });
      });
  }

  fetchSubmediasFromMedia(mediaId) {
    let url = subMediaFromMediaUrl.concat(mediaId);

    this.submediaSpinner.current && this.submediaSpinner.current.showSpinner();
    if (this.state.showEditModal) {
      this.setState({ modalSpinner: true })
    }
    this.setState({ subMedias: [] })

    apiClient.get(url,
      {
        headers: {
          'Reference': `BudgetScreen`
        }
      })
      .then((response) => {
        const data = response.data;
        this.setState({
          subMedias: data,
          submediaReadonly: false,
        }, () => {

          //displaying disabled subMedias in edit dropdown through our e.row.data   
          const enabledSubMedias = this.state.subMedias.filter(obj => {
            return obj.isEnabled === true;
          });
          this.setState({ subMedias: enabledSubMedias });

          //if we are inside the edit form and our submedia is disabeled
          if (this.state.showEditModal) {
            if (enabledSubMedias.find(x => x.subMediaId == this.state.rowInfo.subMediaId) == undefined) {
              var l_SubMedias = enabledSubMedias;
              l_SubMedias.push({
                subMediaId: this.state.rowInfo.subMediaId,
                name: this.state.rowInfo.subMediaName
              })
              l_SubMedias.sort(compare);
              this.setState({ subMedias: l_SubMedias })
            }
          }

          //if we are inside create form and we ahve only 1 submedia
          if (data && data.length === 1 && this.state.showModal) {
            this.onRefreshFromSubMedia();
            //reseting Suggested Fee when Media changes
            this.fetchSuggestedAgencyFees();
          }
        });
      })
      .catch((error) => {
        console.error("Error fetching submedia: ", error);
      }).finally(() => {
        this.submediaSpinner.current && this.submediaSpinner.current.hideSpinner();
        if (this.state.showEditModal) {
          this.setState({ modalSpinner: false })
        }
      });
  }
  
  onRefreshFromSubMedia() {
    let submediaId = this.state.showModal ? this.subMediaRef.current.value : this.subMediaRef_edit.current.value;
    let countryId = this.state.showModal ? this.countryRef.current.value : this.countryRef_edit.current.value;
    let mediaId = this.state.showModal ? this.mediaRef.current.value : this.mediaRef_edit.current.value;
    let agencyId = this.state.showModal ? this.buyingAgencyRef.current.value : this.buyingAgencyRef_edit.current.value;

    //in case we have "Print" than we chose a "Submedia" we change our state so we can add positions based on our submedia selection for both create and edit forms
    if ((this.state.showModal && this.mediaRef.current.selectedOptions[0].text === 'Print') || (this.state.showEditModal && this.mediaRef_edit.current.selectedOptions[0].text === 'Print')) {
      this.setState({ submediaState: true });
    } else {
      this.setState({ submediaState: false });
    }

    if (countryId !== "" && submediaId !== "") {
      this.fetchVehiclesFromCountryAndSubmedia(countryId, submediaId);
      if (mediaId !== "" && agencyId !== "") {
        //reseting Suggested Fee when SubMedia changes
        this.fetchSuggestedAgencyFees();
      }
    } else this.setState({ vehicles: [] });

    if (this.state.showEditModal) {
      this.setState({ edit_submedia_id: submediaId })
    }
    this.fetchPositions(submediaId);
  }

//reseting Suggested Fee (Year, Country, Agency, Media, SubMedia)
fetchSuggestedAgencyFees(  countryId, subMediaId, mediaId, buyingAgencyId, year , fromfetch){
  if(fromfetch){
    let url = suggestedagencyfeesUrl
    .concat(countryId)
    .concat("/")
    .concat(subMediaId)
    .concat("/")
    .concat(mediaId)
    .concat("/")
    .concat(buyingAgencyId)
    .concat("/")
    .concat(year);
    
    fetch(url,
    {
      method: "GET",
      headers: {
        'accept': 'application/json',
        'Authorization': 'Bearer '+localStorage.getItem('token'), 
        'content-type': 'application/json',
    }})   
    .then((res) => res.json())
  .then((data) => 
    {
      if(data.fees != undefined){          
        this.setState({ suggestedFees: data.fees })
      }
      else{
        this.setState({ suggestedFees: '' })
      }
    })
      .catch((error) => {
        console.error("Error fetching fetchSuggestedAgencyFees: ", error);
      });
  }else{

  
  if(this.state.showModal || this.state.showEditModal){
  let submediaId = this.state.showModal ? this.subMediaRef.current.value : this.subMediaRef_edit.current.value;
  let countryId = this.state.showModal ? this.countryRef.current.value : this.countryRef_edit.current.value;
  let mediaId = this.state.showModal ? this.mediaRef.current.value : this.mediaRef_edit.current.value;
  let agencyId = this.state.showModal ? this.buyingAgencyRef.current.value : this.buyingAgencyRef_edit.current.value;
  let year = this.state.showModal ? this.yearRef.current.value : this.yearRef_edit.current.value;

  if(countryId !== "" && submediaId !== "" && mediaId !== "" && agencyId !== ""){
    
    let url = suggestedagencyfeesUrl
    .concat(countryId)
    .concat("/")
    .concat(submediaId)
    .concat("/")
    .concat(mediaId)
    .concat("/")
    .concat(agencyId)
    .concat("/")
    .concat(year);
    
    fetch(url,
    {
      method: "GET",
      headers: {
        'accept': 'application/json',
        'Authorization': 'Bearer '+localStorage.getItem('token'), 
        'content-type': 'application/json',
    }})
    .then((res) => res.json())
  .then((data) => 
    {
      if(data.fees != undefined){          
        this.setState({ suggestedFees: data.fees })
      }
      else{
        this.setState({ suggestedFees: '' })
      }
    });
   }
  }
}
 }

  fetchVehiclesFromCountryAndSubmedia(countryId, submediaId) {
    if (this.state.showModal) {
      this.vehicleRef.current.value = '';
    }
    let url = vehicleFromCountryAndSubmediaUrl
      .concat(countryId)
      .concat("/")
      .concat(submediaId);

    apiClient.get(url)
      .then((response) => {
        const data = response.data;
        this.setState({
          vehicles: data,
          vehicleReadonly: false
        }, function () {
          data.forEach(element => {
            if (element.vehicleName == 'NA') {
              if (this.state.showModal) {
                this.vehicleRef.current.value = element.vehicleId;
              }
            }
          });
        })
      }).catch((error) => {
        console.error("Error fetching fetchVehiclesFromCountryAndSubmedia: ", error);
      });
  }

  fetchCurrencies() {
    apiClient.get(currencyUrl)
      .then((response) => {
        const data = response.data;
        this.setState({ currencies: data });
      })
  }

  onExportToExcel = () => {
    this.exportSpinner.current && this.exportSpinner.current.showSpinner();
    let objectDate = new Date();
    let day = objectDate.getDate();
    let month = objectDate.getMonth();
    let year = objectDate.getFullYear();
    let format = `${day}-${month + 1}-${year}`;
    let folderName = `budgets_extract_${format}`;

      let requestBody = {};
      [
        'filter',
        'searchOperation',
        'searchValue',
        'select',
        'sort',
        'skip',
        'take',
        'totalSummary',
        'userData'
      ].forEach((key) => {
        if (key in loadMyOptions && isNotEmpty(loadMyOptions[key])) {
          requestBody[key] = JSON.stringify(loadMyOptions[key]);
        }
      });

      apiClient.post(`${budgetUrlExport}`, requestBody)
        .then((response) => {
          const data = response.data;
          if (data) {
            exportBudgetListToExcel(data.data);
            toast.success("Budget List export file generated!");
          }
        })
        .finally(() => {
          this.exportSpinner.current && this.exportSpinner.current.hideSpinner();
        });
    }


  toastCallback = (response, successMessage) => {
    if(response){
    if(response.statusCode ==400){
      this.setState({duplicationModal: true})
      return;
    }else{
    if (response && (response.statusCode === 201 || response.statusCode === 200)) {
      this.setState({showSmallModal: false, showModal: false});
      
      toast.success(successMessage);
      this.useRefresh();
     } else toast.error("Error " + response.status);
    }
   }
  };

  insertBudgetList = (budgetList, successMessage) => {
    apiClient.post(budgetUrl, budgetList)
      .then((response) => {
        const data = response.data;
        this.toastCallback(data, successMessage)
      });
  };

  editBudgetList = (budgetList, successMessage) => {
    apiClient.put(budgetUrl, budgetList)
      .then((response) => {
        const data = response.data;
        this.toastCallback(data, successMessage)
      });
  };

  /*
  replacingEmptyPosWithNa = () => {
    //Incase there is no budget details
    console.log("i am here")
    const emptyBudget= `{"BudgetDetails":]}`;
    if (!this.state.budgetdetails || this.state.budgetdetails == emptyBudget) {
      return ''; 
    }

    let posId;
    //getting our NA Id
    for(let i = 0; i < this.state.positions.length; i++) {
      if(this.state.positions[i].positionName === "NA") {
        posId = this.state.positions[i].positionId;
        break;
      }
    }
    
    const budgetdetails = this.state.budgetdetails;
    const newStr = budgetdetails.replace(/'/g, '"');
    const stateObj = JSON.parse(newStr);

    for (let i = 0; i < stateObj.BudgetDetails.length; i++) {
      const item = stateObj.BudgetDetails[i];
      if (item.PositionId === "00000000-0000-0000-0000-000000000000") {
        item.PositionId = posId; // replace with your new ID value
      }
    }

    // convert the object back to a string
    const newBudgetDetails = JSON.stringify(stateObj);

    // update the React state if needed in Ignore popup
    this.setState({budgetdetails: newBudgetDetails});

    return newBudgetDetails;
  }
*/
  // Function to handle input field validation and state updates
  handleValidation = (fieldRef, stateKey) => {
    const value = fieldRef.current.value;
    const isValid = !!value; // Check if the value exists

    this.setState({ [stateKey]: isValid });
    return value;
  };

  onCreateBudget = async () => {
    const year = this.handleValidation(this.yearRef, 'yearValidation');
    const country = this.handleValidation(this.countryRef, 'countriesValidation');
    const buyingAgency = this.handleValidation(this.buyingAgencyRef, 'agencyValidation');
    const maison = this.handleValidation(this.maisonRef, 'maisonValidation');
    const media = this.handleValidation(this.mediaRef, 'mediaValidation');
    const submedia = this.handleValidation(this.subMediaRef, 'submediaValidation');
    const vehicle = this.handleValidation(this.vehicleRef, 'vehicleValidation') || null;
    const objective = this.handleValidation(this.objectiveRef, 'objectiveValidation') || null;
    const currency = this.handleValidation(this.currencyRef, 'currencyValidation');

    if (this.state.exceededLimit) {
      this.setState({ lengthExceededModal: true });
      return;
    }

    let { netVal, n1, n2, n3, n4, n5, n6, n7, n8, n9, n10, n11, n12, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, f1, f2, f3, f4, f5, f6, f7, f8, f9, f10, f11, f12, technicalVal, feeVal, isPositionsValid } = await this.child.current.getValidation();

    let netCont = [n1, n2, n3, n4, n5, n6, n7, n8, n9, n10, n11, n12];
    let techCont = [t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12];
    let feeCont = [f1, f2, f3, f4, f5, f6, f7, f8, f9, f10, f11, f12];

    let netVall = 0;
    let techVall = 0;
    let feeVall = 0;
    let totalEmptyMonth = 0;

    if (netVal) {
      this.setState({ netState: true });
    } else {
      this.setState({ netState: false });
    }

    if (technicalVal) {
      this.setState({ technicalState: true });
    } else {
      this.setState({ technicalState: false });
    }

    if (feeVal) {
      this.setState({ feeState: true });
    } else {
      this.setState({ feeState: false });
    }

    if (isPositionsValid) {
      this.setState({ isPositionsValid: true });
    } else {
      this.setState({ isPositionsValid: false });
    }

    let budgetList = {
      Year: year,
      OrganizationId: maison,
      BuyingAgencyId: buyingAgency,
      MediaId: media,
      SubmediaId: submedia,
      GeoElementId: country,
      VehicleId: vehicle,
      CurrencyId: currency,
      IsBackData: false,
      ObjectiveId: objective,
      BudgetDetails: this.state.budgetdetails,
      Comments: this.budgetListCommentsRef.current != null ? this.budgetListCommentsRef.current.value : this.state.comments
    };
    this.setState({ budgetStates: budgetList });

    for (let i = 0; i < 12; i++) {
      if (!netCont[i] && !techCont[i] && !feeCont[i]) {
        totalEmptyMonth++;
        continue;
      }

      if (!netCont[i] || (!netCont[i] && techCont[i]) || (!netCont[i] && feeCont[i])) {
        this.setState({ netSuperState: false });
        netVall++;
      }

      if (netCont[i] && !techCont[i]) {
        techVall++;
      }
    }

    if (netVall === 0 && totalEmptyMonth !== 12) {
      this.setState({ netSuperState: true });
    } else {
      this.setState({ netSuperState: false });
    }

    if (!(year && country && buyingAgency && maison && media && submedia && vehicle && currency && isPositionsValid && netVal !== 0)) {
      return;
    }

    // Checking if no fees have been entered for any month
    const allFeesEmpty = feeCont.every(fee => !fee);
    this.setState({ showSmallModal: allFeesEmpty });
    if (allFeesEmpty) return;

    if (year && country && buyingAgency && maison && media && submedia && vehicle && currency && netVall === 0 && totalEmptyMonth !== 12) {
      this.insertBudgetList(budgetList, "Budget is created");
      return;
    }
  };

  handleIgnore = (e)=>{
    this.setState({showSmallModal: false});

    if(this.state.yearValidation && this.state.countriesValidation && this.state.agencyValidation && this.state.maisonValidation && this.state.mediaValidation && this.state.submediaValidation && this.state.vehicleValidation && this.state.currencyValidation && this.state.netSuperState && this.state.isPositionsValid){
           
     this.insertBudgetList(
       this.state.budgetStates,
       "Budget is created"
       );
        return;
    }else{
      this.setState({showSmallModal: false});
      return;
    }
  }

  onEditBudgetList = async () => {
    let budgetId = this.state.selectedRowIndex;
    const year = this.handleValidation(this.yearRef_edit, 'yearValidation');
    const country = this.handleValidation(this.countryRef_edit, 'countriesValidation');
    const buyingAgency = this.handleValidation(this.buyingAgencyRef_edit, 'agencyValidation');
    const maison = this.handleValidation(this.maisonRef_edit, 'maisonValidation');
    const media = this.handleValidation(this.mediaRef_edit, 'mediaValidation');
    const submedia = this.handleValidation(this.subMediaRef_edit, 'submediaValidation');
    const vehicle = this.handleValidation(this.vehicleRef_edit, 'vehicleValidation') || null;
    const objective = this.handleValidation(this.objectiveRef_edit, 'objectiveValidation') || null;
    const currency = this.handleValidation(this.currencyRef_edit, 'currencyValidation');

    if (this.state.exceededLimit) {
      this.setState({ lengthExceededModal: true });
      return;
    }

    // "n" stands for net , "f" stands for fee, "t" stands for technical cost, here we are getting all 12 months values and storing them in constants

    let { netVal, n1, n2, n3, n4, n5, n6, n7, n8, n9, n10, n11, n12, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, f1, f2, f3, f4, f5, f6, f7, f8, f9, f10, f11, f12, technicalVal, feeVal, isPositionsValid } = await this.editChild.current.getValidation();

    let netCont = [n1, n2, n3, n4, n5, n6, n7, n8, n9, n10, n11, n12];
    let techCont = [t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12];
    let feeCont = [f1, f2, f3, f4, f5, f6, f7, f8, f9, f10, f11, f12];

    let netVall = 0;
    let techVall = 0;
    let feeVall = 0;
    let totalEmptyMonth = 0;

    if (netVal) {
      this.setState({ netState: true })
    } else { this.setState({ netState: false }) }

    if (technicalVal) {
      this.setState({ technicalState: true })
    } else { this.setState({ technicalState: false }) }

    if (feeVal) {
      this.setState({ feeState: true })
    } else { this.setState({ feeState: false }) }

    if (isPositionsValid) {
      this.setState({ isPositionsValid: true })
    } else { this.setState({ isPositionsValid: false }) }

    //Replace empty position with Na
    //const newBudgetDetails = this.replacingEmptyPosWithNa();

    let budgetList = {
      BudgetId: budgetId,
      Year: year,
      OrganizationId: maison,
      BuyingAgencyId: buyingAgency,
      MediaId: media,
      SubmediaId: submedia,
      GeoElementId: country,
      VehicleId: vehicle,
      ObjectiveId: objective == "" ? null : objective,
      CurrencyId: currency,
      IsBackdata: false,
      BudgetDetails: this.state.budgetdetails,
      Comments: this.budgetListCommentsRef_edit.current != null ? this.budgetListCommentsRef_edit.current.value : this.state.comments
    };
    this.setState({ budgetStatesEdit: budgetList })

    for (let i = 0; i < 12; i++) {
      //incase we didnt entered any value in a month we skip it and continue to the next one
      if ((!netCont[i]) && (!techCont[i]) && (!feeCont[i])) {
        totalEmptyMonth++;
        continue;
      }

      //incase we dont have net for a specific month, or we have only fee and technical cost
      if ((!netCont[i]) || ((!netCont[i]) && (techCont[i])) || ((!netCont[i]) && (feeCont[i]))) {
        this.setState({ netSuperStateEdit: false })
        netVall++;
      }

      //incase we have net with no technical cost
      if (netCont[i] && !techCont[i]) {
        techVall++;
      }

      //incase we have net with no fee
      if (netCont[i] && !feeCont[i]) {
        feeVall++;
      }
    }

    if (netVall === 0 && totalEmptyMonth !== 12) {
      this.setState({ netSuperStateEdit: true })
    } else {
      this.setState({ netSuperStateEdit: false })
    }

    if (!(year && country && buyingAgency && maison && media && submedia && vehicle && currency && isPositionsValid && netVal != 0)) {
      return;
    }

    // Checking if no fees have been entered for any month
    const allFeesEmpty = feeCont.every(fee => !fee);
    this.setState({ showSmallModalEdit: allFeesEmpty });
    if (allFeesEmpty) return;

    if (year && country && buyingAgency && maison && media && submedia && vehicle && currency && netVall == 0 && totalEmptyMonth !== 12) {
      this.editBudgetList(
        budgetList,
        "Budget has been updated"
      );
      return;
    }
  };

  handleIgnoreEdit = (e)=>{
    this.setState({showSmallModalEdit: false});
    if(this.state.yearValidation && this.state.countriesValidation && this.state.agencyValidation && this.state.maisonValidation && this.state.mediaValidation && this.state.submediaValidation && this.state.vehicleValidation && this.state.currencyValidation && this.state.netSuperStateEdit && this.state.isPositionsValid){
      this.editBudgetList(
        this.state.budgetStatesEdit,
        "Budget has been updated"
      );
        return;
    }else{
      this.setState({showSmallModal: false});
      return;
    }
  }

  showConfirmationDelete = (e) =>{
    this.setState({ showConfirmationDelete: true, selectedId:e.row.key, selectedName:e.row.data.name });
  }

  hideConfirmationDelete = () =>{
    this.setState({ showConfirmationDelete: false });
  }

  onCatchDelete = () => {
    let selectedBudgetId = this.state.selectedId;
    apiClient.delete(budgetUrl,
      {
        headers: {
          'key': selectedBudgetId
        }
      })
      .then(response => {
        const data = response.data;
        if (data) {
          this.dataGrid.useRefresh();
          toast.success("Budget has been deleted");
          this.hideConfirmationDelete();
        }
      });
  }

  getQueryString = () => (
    `${url}/BudgetMicroservice/${this.state.pageSize}/${this.state.pageSize * this.state.currentPage}`
  );

  loadData = () => {
    const queryString = this.getQueryString();
    apiClient.get(queryString)
        .then((response) => {
          const data = response.data;
          this.setState({ dataSource: data })
        })
  };

  handleOptionChange(e) {
    if(e.fullName === 'paging.pageSize') {
        this.setState({
            pageSize: e.value 
        });
    }
    if(e.fullName === 'paging.pageIndex') {
        this.setState({
            currentPage: e.value 
        });
    }
  }

    cellRender(e) {
      var comments = e.data.comments;
      let truncatedComments = comments;
      if (comments && comments.length >= 50) {
        truncatedComments = comments.substring(0, 50) + '...';
      }
      return comments != null ? <img style={{width:'20px'}} alt="star icon" title={truncatedComments} src={starimg} /> : '';
    }

  render() {
    const now = new Date();
    let optionsYears = this.state.years.map((year) => (
      year == now.getFullYear()?<option selected value={year}>{year}</option>:<option value={year}>{year}</option>
    ));

    let optionsAgencies = this.state.agencies.map((item) => (
      <option value={item.buyingAgencyId}>{item.name}</option>
    ));

    let optionsCountries = this.state.countries.map((item) => (
      <option value={item.geoElementId}>{item.name}</option>
    ));

    let optionsMaisons = this.state.maisons.map((item) => (
      <option value={item.organizationId}>{item.name}</option>
    ));

    let optionsMedias = this.state.medias.map((item) => (
      <option value={item.mediaId}>{item.name}</option>
    ));

    let optionsSubMedias = this.state.subMedias.map((item) => (
      <option value={item.subMediaId}>{item.name}</option>
    ));

    let optionsVehicles = this.state.vehicles.map((item) => (
      <option value={item.vehicleId}>{item.vehicleName}</option>
    ));

    let optionsCurrencies = this.state.currencies.sort(this.compareCurrencies).map((item) =>
    <option value={item.currencyId}>{item.displayName}</option>
);

    let optionsPositions = this.state.positions.map((item) =>
        <option value={item.positionId}>{item.positionName}</option>
    );

    let optionsObjectives = this.state.objectives.map((item) =>
    <option value={item.objectiveId}>{item.name}</option>
    );    
    
    let exportButton;
    exportButton = <button className={this.state.can_export_to_excel ? "btn-section-header" : "btn-section-header hidden" } 
                          onClick={this.onExportToExcel}>
                          {<>
                          <img className="img-section-header" src={exportimg}/>
                          <LoadingSpinner ref={this.exportSpinner} exportSpinner={true}/>
                          </>}
                          <label>Export To Excel</label></button>;
    let newButton;
      if (this.state.manage_budget_form) 
      {
        newButton = <button className="btn-section-header" onClick={this.openModal}><img className="img-section-header" src={plusimg} /><label>New Budget</label></button>;
      }

      const columns = [
        { dataField: "calendarYearName", caption: "Year", width: "120px", minWidth: "8%", placeholder: "Search Year" },
        { dataField: "comments", caption: "Notes", width: "50px", minWidth: "8%", placeholder: "Search Notes", allowFiltering: false, allowSorting: true, cellRender: this.cellRender },
        { dataField: "country", caption: "Country/Region", width: "100px", minWidth: "18%", placeholder: "Search Country" },
        { dataField: "maison", caption: "Maison", width: "100px", minWidth: "18%", placeholder: "Search Maison" },
        { dataField: "buyingAgencyName", caption: "Agency", width: "150px", placeholder: "Search Buying Agency" },
        { dataField: "mediaName", caption: "Media", width: "150px", placeholder: "Search Media" },
        { dataField: "subMediaName", caption: "SubMedia", width: "150px", placeholder: "Search Submedia"},
        { dataField: "vehicleName", caption: "Vehicle", width: "150px", placeholder: "Search Vehicle"},
        { dataField: "publisherName", caption: "Publisher", width: "150px", placeholder: "Search Publisher"},
        { dataField: "objectiveName", caption: "Objective", width: "150px", placeholder: "Search Objective"},
        { dataField: "currency", caption: "Currency", width: "100px", placeholder: "Search Currency"},
        { dataField: "netYearly", caption: "Net Yearly Total", width: "150px", customizeText: this.customizeNumbers, alignment: "right", allowFiltering: false, placeholder: "Search Net Yearly total"},
        { dataField: "finalCostYearly", caption: "Final Cost Yearly Total", width: "150px", customizeText: this.customizeNumbers, alignment: "right", allowFiltering: false, placeholder: "Search Final cost Yearly total"},
        { dataField: "createdDate", caption: "Created Date", width: "150px", customizeText: this.customizeText, allowFiltering: false, placeholder: "Search Created Date"},
        { dataField: "createdBy", caption: "Created By", width: "150px", placeholder: "Search Created By"},
        { dataField: "updatedDate", caption: "Last Updated Date", width: "150px", customizeText: this.customizeText, allowFiltering: false},
        { dataField: "updatedBy", caption: "Last Updated By", width: "150px", placeholder: "Search Updated By"},
        // Add other columns specific to Profiles component
      ];
  
      const buttonColumnBudget = this.state.manage_budget_form ?  [
        {text: "Edit", icon: editimg, className: "img-grid", name: "edit", onClick: this.openEditModal},
        {text: "Delete", icon: deleteBlue, className: "img-grid", name: "delete", onClick: this.showConfirmationDelete},
        // Additional buttons for Profiles component
      ] : ["",""];

    return (
      <>
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
          <div className="div-section-title">
            <span>{"Budget List"}</span>
          </div>
          <div className="div-section-actions push">
          {exportButton}
          {newButton}
          </div>
        </div>
        <div className="div-body-section-details-body">
          <div className="div-padding-20 div-scroll budget-page">

          <CustomDataGrid
              dataSource={customDataSource}
              keyExpr="budgetId"
              ref={(ref) => (this.dataGrid = ref)}
              rowAlternationEnabled={this.state.rowAlternationEnabled}
              showFilterRow={this.state.showFilterRow}
              currentFilter={this.state.currentFilter}
              showHeaderFilter={this.state.showHeaderFilter}
              columns={columns}
              buttonColumnBudget={buttonColumnBudget}
              remoteOperations={true}
              budgetPage={true}
            />
          </div>
        </div>

        <ConfirmationDelete show={this.state.showConfirmationDelete} hide={this.hideConfirmationDelete} confirm={this.onCatchDelete} title="Confirm"  msg="Are you sure you want to delete this budget ?" firstButton="Ok" secondButton="Cancel" />

   <Modal show={this.state.showModal} onHide={this.handleClose} className="budget-modal" size="xl" fullscreen={this.state.fullscreen}>    
      <Modal.Header closeButton style={{ position: "relative" }}>
       <Modal.Title size="h6">New Budget</Modal.Title>
     <button
        type="button"
        class="btn btn-primary budget-btn"
        onClick={this.fullscreenHandler}
      >
        {this.state.fullscreen ?  <Maximize /> : <Minimize /> }
      </button>
     </Modal.Header>

      <Modal.Body>  
        <Row className="no-wrap-row">        
          <Form.Group className="mb-3 col-md-2" controlId="Name">
          <div className="mb-2 col-md-12">
                <label className="lbl_header">Budget Identification</label>
              </div>
            <Form.Label className={`${this.state.yearValidation ? "normal-title" : "validation-title"}`}>Year  <CircleSign/></Form.Label>
                  <Form.Control
                    className={`select-placeholder ${!this.state.yearValidation && "validation-control"} margin-bot`}
                    placeholder="Year"
                    color="red"
                    ref={this.yearRef}
                    onChange={this.onRefreshFromYear}
                    required
                    as="select"
                    defaultValue={new Date().getFullYear()}
                  >
                    {optionsYears}
                  </Form.Control>
            {!this.state.yearValidation && <p className="p-required">Required</p>}

            <Form.Label className={`${this.state.countriesValidation ? "normal-title" : "validation-title"}`}>Country/Region  <CircleSign/></Form.Label>
                  <Form.Control
                    className={`select-placeholder  ${!this.state.countriesValidation && "validation-control"} margin-bot`}
                    placeholder="Country/Region"
                    ref={this.countryRef}
                    onChange={this.onRefreshFromCountry}
                    required
                    as="select"
                  >
                    {this.state.countries && this.state.countries.length == 1 ? <option selected value={this.state.countries[0].geoElementId}>{this.state.countries[0].name}</option> : <>
                      <option value="" hidden>Country</option>
                      {optionsCountries}
                    </>
                    }
                  </Form.Control>
            {!this.state.countriesValidation && <p className="p-required">Required</p>}
                
            <Form.Label className={`${this.state.maisonValidation ? "normal-title" : "validation-title"}`}>Maison  {<>
          <CircleSign/>
          <LoadingSpinner ref={this.maisonSpinner} size="xs"/>
        </>}</Form.Label>
            <Form.Control  
              className={`select-placeholder ${!this.state.maisonValidation && "validation-control"} margin-bot`} 
              placeholder="Maison" 
              ref={this.maisonRef} 
              onChange={this.onRefreshFromMaison}
              required 
              as="select">
                {this.state.maisons && this.state.maisons.length ==1 ? <option selected value={this.state.maisons[0].organizationId}>{this.state.maisons[0].name}</option> : <>
                <option value="" hidden>Maison</option>
                {optionsMaisons}
                </>
                }
            </Form.Control>
            {!this.state.maisonValidation && <p className="p-required">Required</p>}

            <Form.Label className={`${this.state.agencyValidation ? "normal-title" : "validation-title"}`}>Agency  {<>
          <CircleSign/>
          <LoadingSpinner ref={this.agencieSpinner} size="xs"/>
        </>}</Form.Label>
            <Form.Control  
              className={`select-placeholder  ${!this.state.agencyValidation && "validation-control"} margin-bot-1-5`} 
              placeholder="Agency" 
              ref={this.buyingAgencyRef} 
              onChange={this.onRefreshFromAgency}
              required 
              as="select">
                {this.state.agencies && this.state.agencies.length ==1 ? <option selected value={this.state.agencies[0].buyingAgencyId}>{this.state.agencies[0].name}</option> : <>
                <option value="" hidden>Agency</option>
                {optionsAgencies}
                </>
                }
            </Form.Control>
             {!this.state.agencyValidation && <p className="p-required">Required</p>}
            
            <div className="mb-2 col-md-12 mt-3">
                <label className="lbl_header">Media Information</label>
              </div>

            <Form.Label className={`${this.state.mediaValidation ? "normal-title" : "validation-title"}`}>Media  <CircleSign/></Form.Label>
            <Form.Control  
              className={`select-placeholder  ${!this.state.mediaValidation && "validation-control"} margin-bot`} 
              placeholder="Media" 
              ref={this.mediaRef} 
              onChange={this.onRefreshFromMedia}
              required 
              as="select">
                {this.state.medias && this.state.medias.length ==1 ? <option selected value={this.state.medias[0].mediaId}>{this.state.medias[0].name}</option> : <>
                <option value="" hidden>Media</option>
                {optionsMedias}
                </>
                }
            </Form.Control>
            {!this.state.mediaValidation && <p className="p-required">Required</p>}

            <Form.Label className={`${this.state.submediaValidation ? "normal-title" : "validation-title"}`}>Submedia  {<>
          <CircleSign/>
          <LoadingSpinner ref={this.submediaSpinner} size="xs"/>
        </>}</Form.Label>
            <Form.Control  
              className={`select-placeholder ${!this.state.submediaValidation && "validation-control"} margin-bot`} 
              placeholder="Submedia" 
              ref={this.subMediaRef} 
              onChange={this.onRefreshFromSubMedia}
              readOnly={this.state.submediaReadonly}
              disabled={this.state.submediaReadonly}
              required 
              as="select">
                {this.state.subMedias && this.state.subMedias.length ==1 ? <option selected value={this.state.subMedias[0].subMediaId}>{this.state.subMedias[0].name}</option> : <>
                <option value="" hidden>Submedia</option>
                {optionsSubMedias}
                </>
                }
            </Form.Control>
            {!this.state.submediaValidation && <p className="p-required">Required</p>}
            
            <Form.Label className={`${this.state.vehicleValidation ? "normal-title" : "validation-title"}`}>Vehicle  <CircleSign/></Form.Label>
            <Form.Control  
              className={`select-placeholder ${!this.state.vehicleValidation && "validation-control"} margin-bot`} 
              placeholder="Vehicle" 
              ref={this.vehicleRef} 
              readOnly={this.state.vehicleReadonly}
              disabled={this.state.vehicleReadonly}
              required 
              as="select">
                  <option value="" hidden>Vehicle</option>
                  {optionsVehicles}
            </Form.Control>
            {!this.state.vehicleValidation && <p className="p-required">Required</p>}

            <div className={`${this.state.showObjectives ? "" : "hidden"}`}>
            <Form.Label className={`${this.state.objectiveValidation ? "normal-title" : "validation-title"}`}>Objective  <CircleSign/></Form.Label>
            <Form.Control  
              className={`select-placeholder ${!this.state.objectiveValidation && "validation-control"} margin-bot`} 
              placeholder="Objective" 
              ref={this.objectiveRef} 
              required 
              as="select">
                  <option value="" hidden>Objective</option>
                  {optionsObjectives}
            </Form.Control>
            {!this.state.objectiveValidation && <p className="p-required">Required</p>}
            </div>
          </Form.Group>
            
          <Form.Group className="mb-3 col-md-10" controlId="Name">
          <label className="cost-style">Costs</label>
          <Row >
          <Form.Group className="mb-3 col-md-6 flex-center">
          <Form.Label className={`${this.state.currencyValidation ? "normal-title" : "validation-title"} min-w-100 margin-auto`}>Currency  <CircleSign/></Form.Label>
         
            <Form.Control  
              className={`select-placeholder ${!this.state.currencyValidation && "validation-control"} max-w-450`} 
              placeholder="Currency" 
              ref={this.currencyRef} 
              required
              defaultValue="" 
              as="select">
                {this.state.currencies && this.state.currencies.length ==1 ? <option selected value={this.state.currencies[0].currencyId}>{this.state.currencies[0].displayName}</option> : <>
                <option value="" hidden>Currency</option>
                {optionsCurrencies}
                </>
                }
            </Form.Control> 
            {!this.state.currencyValidation && <p className="p-required" style={{margin:"auto 5px"}}>Required</p>}
            </Form.Group>
            
            <Form.Group className="mb-3 col-md-6 flex-center">
          <Form.Label className="min-w-150 margin-auto">Suggested Fee (in %)</Form.Label>
            <Form.Control 
              className="max-w-450"
              placeholder="Suggested Fee (in %)"               
              required 
              disabled={true}
              value={this.state.suggestedFees}
              type="text">              
            </Form.Control> 
            </Form.Group>  
            </Row>
           
             <Form.Group className="mb-3 col-md-6 flex-center" style={{paddingRight:"12px"}}>
          <Form.Label className="min-w-100 margin-auto">Notes</Form.Label>   
          <div className="notes-div">

          {(this.state.reachedLimit || this.state.exceededLimit)  && <p style={{marginBottom:"3px"}} className="p-required"> Please note that the maximum allowed characters is 500. You have reached this limit.</p>}

          {this.state.showButton ? (<button onClick={this.addButtonHandler} style={{border:"0", background:"none"}}><AddIcon /></button>) : (
            
            <Form.Control            
            className="max-w-450"
            type="text"
            autoComplete="new-password"
            onChange={this.handleCommentChange}
            ref={this.budgetListCommentsRef} 
            placeholder="Comments"
            maxLength={500}
            />
            )}
            </div>
           </Form.Group>
            
              <MonthlySetup data={{ setupChanged: this.setupChanged.bind(this) }} showUnitPositionSampling={this.state.showUnitPositionSampling} positionsData={optionsPositions} submediaState={this.state.submediaState} ref={this.child} updateNbrOfMnthToHide={this.hideLines.bind(this)}/>

        </Form.Group>
        </Row>     
      </Modal.Body>
      <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onCreateBudget}>
          Create Budget
        </ButtonBootstrap>
        <ButtonBootstrap variant="secondary"  className='btnSecondary' onClick={this.handleClose}>
          Cancel
        </ButtonBootstrap>
      </Modal.Footer>
    </Modal> 

           <SmallModal
              show={this.state.showSmallModal}
              hide={this.closeSmallModal}
              handleIgnore={this.handleIgnore}
              title="No fees"
              content='You have not input any fee for this Budget Form. Click "Back to Budget
                      Form" if this is an oversight or click "Ignore" to pursue and save the
                      Budget Form.'
              blueButton="Ignore"
              firstButton={true}
              secondButton={true}
            />
            
           <SmallModal
            show={this.state.duplicationModal}
            hide={this.closeDuplicationModal}
            handleIgnore={this.doubleCloseModals}
            title="Duplicate"
            content='A budget form already exists for the same scope, your updates cannot be saved. Please go back to the Budget List to edit the corresponding form.'
            blueButton="Back to Budget List"
            firstButton={true}
            secondButton={false}
            />

          <SmallModal
            show={this.state.lengthExceededModal}
            hide={this.closeLengthExceededModal}
            title="Reduce notes"
            content='Please reduce your notes. Notes should be less than 500 characters.'
            blueButton=""
            firstButton={false}
            secondButton={true}
            />
 
     <Modal
       show={this.state.showEditModal}
       onHide={this.handleEditClose}
       className="budget-modal" size="xl" fullscreen={this.state.fullscreen}>
          <Modal.Header closeButton>
            <Modal.Title size="h6"> Edit Budget</Modal.Title>
            <button
            type="button"
            class="btn btn-primary budget-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
          </Modal.Header>

              <LoadPanel
                visible={this.state.modalSpinner}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
              /> 

          <Modal.Body>
          <Row className="no-wrap-row">
          <Form.Group className="mb-3 col-md-2" controlId="Name">
            <Row>
              <Form.Group className="mb-3 col-md-12" controlId="Name">
              <div className="mb-2 col-md-12">
                <label className="lbl_header">Budget Identification</label>
              </div>
                <Form.Label className={`${this.state.yearValidation ? "normal-title" : "validation-title"}`}>Year <CircleSign/></Form.Label>
                <Form.Control
                  className={`${!this.state.yearValidation && "validation-control"} margin-bot`} 
                  placeholder="Year"
                  value={this.state.editOptionsYears}
                  readOnly
                  ref={this.yearRef_edit}
                  disabled
                  as="select"
                >
                  <option>{this.state.editOptionsYears}</option>
                </Form.Control>
                {!this.state.yearValidation && <p className="p-required">Required</p>}

                <Form.Label className={`${this.state.countriesValidation ? "normal-title" : "validation-title"}`}>Country/Region  <CircleSign/></Form.Label>
                <Form.Control
                  className={`${!this.state.countriesValidation && "validation-control"} margin-bot`}
                  placeholder="Country/Region"
                  value={this.state.edit_country_id}
                  ref={this.countryRef_edit}
                  disabled
                  as="select"
                >
                  <option value="" hidden>Country</option>
                  {optionsCountries}
                </Form.Control>
                {!this.state.countriesValidation && <p className="p-required">Required</p>}

                <Form.Label className={`${this.state.maisonValidation ? "normal-title" : "validation-title"}`}>Maison  <CircleSign/></Form.Label>
                <Form.Control
                  className={`${!this.state.maisonValidation && "validation-control"} margin-bot`}
                  placeholder="Maison"    
                  value={this.state.edit_maison_id}
                  ref={this.maisonRef_edit}
                  disabled
                  as="select"
                >
                  <option value="" hidden>Maison</option>
                  {optionsMaisons}
                </Form.Control>
                {!this.state.maisonValidation && <p className="p-required">Required</p>}

                <Form.Label className={`${this.state.agencyValidation ? "normal-title" : "validation-title"}`}>Agency  <CircleSign/></Form.Label>
                <Form.Control
                  className={`${!this.state.agencyValidation && "validation-control"} margin-bot-1-5`}
                  placeholder="Agency"
                  value={this.state.edit_buying_agency_id}
                  ref={this.buyingAgencyRef_edit}
                  disabled
                  as="select"
                >
                  <option value="" hidden>Agency</option>
                  {optionsAgencies}
                </Form.Control>
                {!this.state.agencyValidation && <p className="p-required">Required</p>}


                <div className="mb-2 col-md-12 mt-3">
                <label className="lbl_header">Media Information</label>
                 </div>

                <Form.Label className={`${this.state.mediaValidation ? "normal-title" : "validation-title"}`}>Media  <CircleSign/></Form.Label>
                <Form.Control
                  className={`${!this.state.mediaValidation && "validation-control"} margin-bot`} 
                  placeholder="Media"
                  ref={this.mediaRef_edit}
                  value={this.state.edit_media_id}
                  disabled
                  as="select"
                >
                  <option value="" hidden>Media</option>
                  {optionsMedias}
                </Form.Control>
                {!this.state.mediaValidation && <p className="p-required">Required</p>}

                <Form.Label className={`${this.state.submediaValidation ? "normal-title" : "validation-title"}`}>Submedia  <CircleSign/></Form.Label>
                <Form.Control
                  className={`${!this.state.submediaValidation && "validation-control"} margin-bot`} 
                  placeholder="Submedia"
                  ref={this.subMediaRef_edit}
                  value={this.state.edit_submedia_id}
                  onChange={this.onRefreshFromSubMedia}
                  required
                  as="select"
                >
                  <option value="" hidden>Submedia</option>
                  {optionsSubMedias}
                </Form.Control>
                {!this.state.submediaValidation && <p className="p-required">Required</p>}

                <Form.Label className={`${this.state.vehicleValidation ? "normal-title" : "validation-title"}`}>Vehicle  <CircleSign/></Form.Label>
                <Form.Control
                  className={`${!this.state.vehicleValidation && "validation-control"} margin-bot`} 
                  placeholder="Vehicle"
                  value={this.state.edit_vehicle_id}
                  ref={this.vehicleRef_edit}
                  readOnly={this.state.vehicleReadonly}
                  disabled={this.state.vehicleReadonly}
                  onChange={()=>this.setState({edit_vehicle_id: this.value})}
                  required
                  as="select"
                >
                  <option value="" hidden>Vehicle</option>
                  {optionsVehicles}
                </Form.Control>
                {!this.state.vehicleValidation && <p className="p-required">Required</p>}

                <div className={`${this.state.showObjectives ? "" : "hidden"}`}>
            <Form.Label className={`${this.state.objectiveValidation ? "normal-title" : "validation-title"}`}>Objective  <CircleSign/></Form.Label>
            <Form.Control 
              className={`${!this.state.objectiveValidation && "validation-control"} margin-bot`} 
              placeholder="Objective" 
              value={this.state.edit_objective_id}
              ref={this.objectiveRef_edit} 
              onChange={()=>this.setState({edit_objective_id: this.value})}
              required 
              as="select">
                  <option value="" hidden>Objective</option>
                  {optionsObjectives}
            </Form.Control>
            {!this.state.objectiveValidation && <p className="p-required">Required</p>}
            </div>
          </Form.Group>
         </Row>
       </Form.Group>

        <Form.Group className="mb-3 col-md-10" controlId="Name">
        <label className="cost-style">Costs</label>
         <Row >
          <Form.Group className="mb-3 col-md-6 flex-center" >
          <Form.Label className={`${this.state.currencyValidation ? "normal-title" : "validation-title"} min-w-100 margin-auto`}>Currency  <CircleSign/></Form.Label>
         
            <Form.Control  
              className={`${!this.state.currencyValidation && "validation-control"} max-w-450`} 
              placeholder="Currency" 
              ref={this.currencyRef_edit} 
              required 
              as="select">
                  <option value="" hidden>Currency</option>
                  {optionsCurrencies}
            </Form.Control> 
            {!this.state.currencyValidation && <p className="p-required" style={{margin:"auto 5px"}}>Required</p>}
            </Form.Group>
            
            <Form.Group className="mb-3 col-md-6 flex-center">
          <Form.Label className="min-w-150 margin-auto">Suggested Fee (in %)</Form.Label>
            <Form.Control 
              className="max-w-450"
              placeholder="Suggested Fee (in %)"               
              required 
              disabled={true}
              value={this.state.suggestedFees}
              type="text">              
            </Form.Control> 
            </Form.Group>  
            </Row>

       <Form.Group className="mb-3 col-md-6 flex-center" style={{paddingRight:"12px", padding: "6px !important"}}>
          <Form.Label className="min-w-100 margin-auto">Notes</Form.Label>
          <div className="notes-div">

          {(this.state.reachedLimit || this.state.exceededLimit) && <p style={{marginBottom:"3px"}} className="p-required"> Please note that the maximum allowed characters is 500. You have reached this limit.</p>}

          {this.state.showStar && this.state.showButton  ? (<button onClick={this.addStarHandler} style={{border:"0", background:"none"}}><img alt="start" style={{width:'20px', padding:"6px 0"}} src={starimg} /></button>) : this.state.showButton ? (<button onClick={this.addButtonHandler} style={{border:"0", background:"none"}}><AddIcon /></button>) : (<Form.Control        
             className="max-w-450"    
             type="text"
             autoComplete="new-password"
             onChange={this.handleCommentChange}
             onFocus={this.handleCommentFocus}
             ref={this.budgetListCommentsRef_edit} 
             placeholder="Comments"
             maxLength={500}
            />
          )}
        </div>
        </Form.Group>

        <MonthlySetup data={{ setupChanged: this.setupChanged.bind(this) }} showUnitPositionSampling={this.state.showUnitPositionSampling} positionsData={optionsPositions} submediaState={this.state.submediaState} budgetDetailsData={this.state.budgetDetailsData} ref={this.editChild} updateNbrOfMnthToHide={this.hideLines.bind(this)}/>
        
        </Form.Group>
        </Row>
      </Modal.Body>

     <Modal.Footer>
      <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onEditBudgetList}>
              Update Budget
      </ButtonBootstrap>
            <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleEditClose}>
              Cancel
            </ButtonBootstrap>
          </Modal.Footer>
        </Modal>

        <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Your updates won't be saved. Are you sure you want to leave this page
          ?"/>

          <SmallModal
            show={this.state.showSmallModalEdit}
            hide={this.closeSmallModalEdit}
            handleIgnore={this.handleIgnoreEdit}
            title="No fees"
            content='You have not input any fee for this Budget Form. Click "Back to Budget
                    Form" if this is an oversight or click "Ignore" to pursue and save the
                    Budget Form.'
            blueButton="Ignore"
            doubleButton={true}
            firstButton={true}
            secondButton={true}
          />

      </div>
      <ToastContainer position="bottom-right"/>
      </>
    );
  }

  onShowFilterRowChanged(e) {
    this.setState({
      showFilterRow: e.value,
    });
    this.clearFilter();
  }

  onShowHeaderFilterChanged(e) {
    this.setState({
      showHeaderFilter: e.value,
    });
    this.clearFilter();
  }

  onCurrentFilterChanged(e) {
    this.setState({
      currentFilter: e.value,
    });
  }

  clearFilter() {
    this.dataGrid.clearFilter();
  }
}

export default BudgetList;